module.exports = __webpack_public_path__ + "media/stylesheets/images/sareye_heli-f3c61c272690a0af7f95c146d016d352.jpg";